import {useApi} from "../Api";
import {RateProductCodeLocationGroupEntityRequest} from "../types/rateProductCodeLocationGroup";

export const useRateProductCodeLocationGroupRepository = () => {
    const {POST} = useApi();

    const PATH = "/pricing/rate-product-code-location-group";

    function postRateProductCodeLocationGroupAll({rateProductCodeLocationGroupEntityRequest}: { rateProductCodeLocationGroupEntityRequest: RateProductCodeLocationGroupEntityRequest }): Promise<RateProductCodeLocationGroupEntityRequest> {
        return POST(`${PATH}/new-association`, rateProductCodeLocationGroupEntityRequest);
    }


    return {
        postRateProductCodeLocationGroupAll
    };
};